import React, { useEffect } from 'react';
import './App.css';
import RouterView from './router/rooterView';
import smoothscroll from 'smoothscroll-polyfill';
import { registerMicroApps, start, RegistrableApp } from 'qiankun';
import { qkUrl } from './config/config';
import utils from './utils/utils';

smoothscroll.polyfill();

class App extends React.Component {

  componentWillMount(): void {
    const urlParams = utils.getUrlParams() || {};
    this.initUrlParams(urlParams);
  }

  componentDidMount() {
    const getActiveRule = (hash: any) => (location: any) => location.hash.startsWith(hash)

    // 注册子应用
    registerMicroApps(
      [
        {
          name: 'scale', //微应用的名称，微应用之间必须确保唯一(微应用中package.json中的name)
          entry: qkUrl, //微应用的entry地址
          container: '#scaleContainer',//微应用的容器节点的选择器
          activeRule: getActiveRule('#/scale'),//微应用的激活规则
        },
      ]
    );
    start()
    const urlParams = utils.getUrlParams() || {};
    this.initUrlParams(urlParams);
  }

  // 存储从小程序里带入进来的信息
  initUrlParams(urlParams: any = {}) {
    const _urlParam = urlParams;
    // 从小程序哪个路由进来
    if (_urlParam.from) {
        localStorage.setItem('OriginUrlParam', JSON.stringify(_urlParam));
    }
    // 小程序登录后跳转
    if (_urlParam.data) {
        let _data: any = {};
        try {
            _data = JSON.parse(decodeURIComponent(_urlParam.data));
        } catch (error) {
            _data = {};
        }
        let user = {
            userName: _data.userName,
            tenantName: _data.tenantName,
            tenantCode: _data.tenantCode || _urlParam.tenantCode,
            token: _data.token,
            roleCode: _data.roleCode,
            roleCodes: _data.roleCodes,
            userCode: _data.account,
            tenantConfig: _data.tenantConfig,
            isGuest: !!_data.isGuest // 是否为游客
        }
        //保存登录信息
        sessionStorage.setItem('token', JSON.stringify(user));
        localStorage.setItem('token', JSON.stringify(user));
        localStorage.setItem('tenantCode', _data.tenantCode || _urlParam.tenantCode);
    }
    if (_urlParam.source) {
      sessionStorage.setItem('CSODoctorSource', _urlParam.source);
    }
    if (_urlParam.sourceType) {
      sessionStorage.setItem('CSODoctorSourceType', _urlParam.sourceType);
    }
    if (_urlParam.projectCode) {
      sessionStorage.setItem('CSODoctorProjectCode', _urlParam.projectCode);
    }
    if (_urlParam.projectCode == '') {
      sessionStorage.setItem('CSODoctorProjectCode', '');
    }
}

  render() {
    return (
      <div className="App" id='scaleContainer'>
        <RouterView></RouterView>
      </div>
    );
  }
}

export default App;